export { default } from "./ImageLightbox";
export type { ImageLightboxProps, ImageSlide } from "./ImageLightbox";
